import { render, staticRenderFns } from "./OsPreditiva.vue?vue&type=template&id=24ef7f7a&"
import script from "./OsPreditiva.vue?vue&type=script&lang=js&"
export * from "./OsPreditiva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports